const PageLoader = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-slate-50">

      <div className="flex flex-col items-center gap-4">

        {/* Spinner */}
        <div className="w-10 h-10 border-4 border-slate-200 border-t-blue-600 rounded-full animate-spin"></div>

        {/* Text */}
        <p className="text-sm text-slate-500">
          Verifying session...
        </p>

      </div>

    </div>
  )
}

export default PageLoader